module.exports = __webpack_public_path__ + "static/level3-d650df54ca6111bde226867b742d9736.png";